import {AppActionType} from "../../const/actionType";

const initialState = {
  authtoken: undefined,
  user: undefined,
  menu: [],
  swVersion: null,
  isSavingReview: false,
  currentPeriod: {
    id: null,
    periode: null,
    status: null,
  },
  consolidationStatus: null,
};

export default function appStateReducer(state = initialState, action) {
  switch (action.type) {
    case AppActionType.SET_IS_SAVING_REVIEW:
      return {...state, isSavingReview: action.isSavingReview};
    case AppActionType.SET_USER:
      return {...state, user: action.value};
    case AppActionType.SET_AUTH_TOKEN:
      if (action.value) {
        return {...state, authtoken: action.value};
      } else {
        return {...state, authtoken: action.value};
      }
    case AppActionType.SET_MENU:
      return {...state, menu: action.value};
    case AppActionType.SET_CURRENT_PERIOD_ID:
      return {...state, currentPeriod: action.value};
    case AppActionType.LOGOUT:
      return {...state, authtoken: undefined, user: undefined, menu: []};
    case AppActionType.SET_SW_VERSION:
      return {...state, swVersion: action.value};
    case AppActionType.SET_CONSOLIDATION_STATUS:
      return {...state, consolidationStatus: action.value};
    default:
      return state;
  }
}
